import { ContainerEnvironment } from '@fluidx/office-fluid-types';
import { CatalogContainerPackageName, Ch5ContainerPackageName, OfficeFluidContainerPackageName } from './Constants';
import { getCdnBaseUrl, getFluidExperienceCdnBaseUrl } from '@fluidx/utilities';
import { ITelemetryBaseLogger } from '@fluidframework/common-definitions';
import {
  getCodeLoadDetailsFromNetwork,
  getFFXCodeDetailsProvider,
  getOfficeContainerEnvironmentOverride,
  OfficeContainerCodeLoadDetails
} from './FFXCodeDetailsHelpers';

export async function getOfficeContainerCodeLoadDetailsFromNetwork(
  containerEnvironment: ContainerEnvironment,
  logger?: ITelemetryBaseLogger
): Promise<OfficeContainerCodeLoadDetails> {
  const containerEnvironmentToUse = getOfficeContainerEnvironmentOverride(logger) || containerEnvironment;

  const url = `${getCdnBaseUrl(containerEnvironmentToUse)}/container/versionless/officeContainerCodeLoadDetails.json`;

  return getCodeLoadDetailsFromNetwork(url);
}

export const getOfficeContainerCodeDetailsProvider = (logger?: ITelemetryBaseLogger, localeHint?: string) =>
  getFFXCodeDetailsProvider(
    OfficeFluidContainerPackageName,
    (containerEnvironment) => getOfficeContainerCodeLoadDetailsFromNetwork(containerEnvironment, logger),
    logger,
    localeHint
  );

export async function getCh5ContainerCodeLoadDetailsFromNetwork(
  containerEnvironment: ContainerEnvironment,
  logger?: ITelemetryBaseLogger
): Promise<OfficeContainerCodeLoadDetails> {
  // We use the same environment override as the office-fluid-container for now
  const containerEnvironmentToUse = getOfficeContainerEnvironmentOverride(logger) || containerEnvironment;

  const url = `${getFluidExperienceCdnBaseUrl(
    containerEnvironmentToUse
  )}/ch5-container/versionless/ch5ContainerCodeLoadDetails.json`;

  return getCodeLoadDetailsFromNetwork(url);
}

export const getCh5ContainerCodeDetailsProvider = (logger?: ITelemetryBaseLogger, localeHint?: string) =>
  getFFXCodeDetailsProvider(
    Ch5ContainerPackageName,
    (containerEnvironment) => getCh5ContainerCodeLoadDetailsFromNetwork(containerEnvironment, logger),
    logger,
    localeHint
  );

export async function getCatalogContainerCodeLoadDetailsFromNetwork(
  containerEnvironment: ContainerEnvironment,
  logger?: ITelemetryBaseLogger
): Promise<OfficeContainerCodeLoadDetails> {
  // We use the same environment override as the office-fluid-container for now
  const containerEnvironmentToUse = getOfficeContainerEnvironmentOverride(logger) || containerEnvironment;

  const url = `${getFluidExperienceCdnBaseUrl(
    containerEnvironmentToUse
  )}/catalog-container/versionless/catalogContainerCodeLoadDetails.json`;

  return getCodeLoadDetailsFromNetwork(url);
}

export const getCatalogContainerCodeDetailsProvider = (logger?: ITelemetryBaseLogger, localeHint?: string) =>
  getFFXCodeDetailsProvider(
    CatalogContainerPackageName,
    (containerEnvironment) => getCatalogContainerCodeLoadDetailsFromNetwork(containerEnvironment, logger),
    logger,
    localeHint
  );
